import { IButtonList, ITab } from 'src/common/interfaces/dtos/ITabs';
import { tabMapping } from 'src/command-menu/tab-mapping';
import { IActionButton } from '../../common/interfaces/dtos/ICashOfficeActionButton';
import { store } from '../../common/redux/configure-store';
import { ICommandGroupMap, ICommandsGroup } from '../../common/interfaces/dtos/ICommandsGroup';

export const assignClickHandler = (actionButton): IActionButton => ({
  ...actionButton,
  handleClick: () => {
    // When pos config supports it, dispatch handler by id. e.g. CommandsActions.dispatch(actionButton.id);
  },
});

export const generateActionButtonsFactory = (
  commandsGroup: ICommandsGroup,
): (() => IActionButton[]) => {
  const commands = commandsGroup?.commandsList || [];
  return () =>
    commands
      .map(cc => ({
        id: cc.name,
        text: cc.name,
        imageUrl: cc.commandImageUrl,
        isDisabled: !cc.isActive,
      }))
      .map(assignClickHandler);
};

export const generateButtonList = (arg: ICommandGroupMap): IButtonList | undefined => {
  const commandsGroup = arg['DefaultCommandGroup'];
  if (commandsGroup) {
    return {
      actions: generateActionButtonsFactory(commandsGroup),
      testId: 'default-command-group',
      title: 'DefaultCommandGroup',
    };
  }
  return undefined;
};

export const convertCommands = (t: ITab): ITab => {
  const { commands, ...tab } = t;

  if (commands) {
    tab.buttonList = generateButtonList(commands);
  }

  return tab;
};

export const getMiddleAreaTabs = (activeTransaction: boolean): ITab[] => {
  const { defaultTabs, saleTabs } = store.getState().tabMenu;
  const tabs: ITab[] = activeTransaction ? saleTabs : defaultTabs;

  const middleAreaTabs = tabs
    .map(tab => ({
      ...tab,
      ...tabMapping.find(x => tab.tabId === x.tabId),
      displayName: tab.displayName,
    }))
    .map(convertCommands);

  return middleAreaTabs;
};
